<template>
    <div class="card">
        <div class="card-header">Centrum správ</div>
        <div class="card-body pt-3 pl-3 pr-3">
            <Loading class="mt-2 mb-2" v-if="loading"/>
            <div class="text-center" v-if="!loading && !items.length">
                <small>V schránke sa nenachádzajú žiadne správy.</small>
            </div>
            <table class="table table-standard table-sm" v-if="!loading && items.length">
                <thead>
                    <tr>
                        <th>Dátum prijatia</th>
                        <th>Predmet</th>
                        <th>Typ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items"
                        @click="openMessage(item, index)"
                        class="c-pointer"
                        :class="{'grey-row': item.opened}"
                    >
                        <td>{{item.date|date}}</td>
                        <td>{{item.subject}}</td>
                        <td>{{item.messageType}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Loading from "../../../components/Loading";
    export default {
        name: "List",
        components: {
            Loading
        },
        computed: {
            loading() {
                return this.$store.state.message.loading;
            },
            items() {
                return this.$store.state.message.items;
            }
        },
        methods: {
            openMessage(item, index) {
                if (!item.opened) {
                    this.$store.dispatch('message/markRead', {
                        id: item.idSlider,
                        index: index
                    });
                }

                this.$router.push({
                    name: 'message',
                    params: {
                        id: index
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>